import { hosts } from "../../../yoello-lib/modules/host/Hosts";
import { ESignupStages } from "../types";

export const leadStages: Record<string, ESignupStages> = {
    [hosts.rms]: ESignupStages.ACQUIRER,
    [hosts.cardsaver]: ESignupStages.ACQUIRER,
    [hosts.barclaycard]: ESignupStages.COMPLETED,
    [hosts.worldpay]: ESignupStages.COMPLETED,
    [hosts.zerobubble]: ESignupStages.COMPLETED,
    [hosts.bna]: ESignupStages.COMPLETED,
    [hosts.deliverect]: ESignupStages.COMPLETED,
    [hosts.ncr]: ESignupStages.COMPLETED,
    [hosts.oracle]: ESignupStages.COMPLETED,
    [hosts.zonal]: ESignupStages.COMPLETED,
    [hosts.tevalis]: ESignupStages.COMPLETED,
}